import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'
import Cookie from '../config/cookie'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user_id: localStorage.getItem('user_id'),
    token: Cookie.token(),
    userInfo: JSON.parse(localStorage.getItem('userInfo'))
  },
  mutations,
  actions
})



// WEBPACK FOOTER //
// ./src/vuex/index.js